import CheckoutComponent from "./components/CommonComponents/Checkout";
import { CommingSoon } from "./components/CommonComponents/ComingSoon";
import Dashboard from "./components/Dashboard/Dashboard";
import DealerDashboard from "./components/Dealer/DealerDashboard";
import DealerMaster from "./components/Dealer/DealerMaster";
import DealerProfile from "./components/Dealer/DealerProfile";
import DealerTypeMaster from "./components/Dealer/DealerTypeMaster";
import EmailServiceProvider from "./components/GeneralSettings/EmailServiceProvider";
import EmailTemplateMaster from "./components/GeneralSettings/EmailTemplateMaster";
import SMSSenderIdMaster from "./components/GeneralSettings/SMSSenderIDMaster";
import SMSServiceProvider from "./components/GeneralSettings/SMSServiceProvider";
import SMSTemplateMaster from "./components/GeneralSettings/SMSTemplateMaster";
import AssetMaster from "./components/Master/AssetMaster";
import AssetProductMaster from "./components/Master/AssetProductMaster";
import AssetTypeMaster from "./components/Master/AssetTypeMaster";
import ManufactureMaster from "./components/Master/ManufactureMaster";
import ModalMaster from "./components/Master/ModalMaster";
import PinCodeMaster from "./components/Master/PinCodeMaster";
import ProductMaster from "./components/Master/ProductMaster";
import CancellationRequest from "./components/Reports/CancellationRequest";
import CancellationRequestReport from "./components/Reports/CancellationRequestReport";
import DealerReport from "./components/Reports/DealerReport";
import MISReport from "./components/Reports/MISReport";
import PaymentReport from "./components/Reports/PaymentReport";
import SaleCancellationRequest from "./components/Reports/SaleCancellationRequest";
import CancelAndInitiatRefund from "./components/Reports/CancelAndInitiatRefund";
import SuccessPaymentReport from "./components/Reports/SuccessPaymentReport";
import SaleReport from "./components/Reports/SaleReport";
import UserLogReport from "./components/Reports/UserLogReport";
import SaleEntry from "./components/SaleEntry/SaleEntry";
import ChangePassword from "./components/UserSection/ChangePassword";
import GroupMasterForm from "./components/UserSection/GroupMaster";
import GroupMenuAccess from "./components/UserSection/GroupMenuAccess";
import ResetPassword from "./components/UserSection/ResetPassword";
import UserMaster from "./components/UserSection/UserMaster";
import UserProfile from "./components/UserSection/UserProfile";
import SMSReport from "./components/Reports/SMSReport";

const AppRoutes = [
    {
        path: '*',
        element: CommingSoon
    }, {
        path: '/User/UserMaster',
        element: UserMaster
    }, {
        path: '/User/ChangePassword',
        element: ChangePassword
    }, {
        path: '/User/UserGroup',
        element: GroupMasterForm
    }, {
        path: '/User/ResetPassword',
        element: ResetPassword
    }, {
        path: '/User/GroupRights',
        element: GroupMenuAccess
    }, {
        path: '/Master/AssetTypeMaster',
        element: AssetTypeMaster
    },
    {
        path: '/Master/AssetMaster',
        element: AssetMaster
    },
    {
        path: '/Master/ProductMaster',
        element: ProductMaster
    },
    {
        path: '/Master/ProductPriceMaster',
        element: AssetProductMaster
    },
    {
        path: '/GeneralSetting/SMSServiceProvider',
        element: SMSServiceProvider
    },
    {
        path: '/GeneralSetting/SMSSenderIdMaster',
        element: SMSSenderIdMaster
    },
    {
        path: '/GeneralSetting/SMSTemplateMaster',
        element: SMSTemplateMaster
    },
    {
        path: '/Report/UserLogReport',
        element: UserLogReport
    },
    {
        path: '/GeneralSetting/EmailServiceProvider',
        element: EmailServiceProvider
    },
    {
        path: '/GeneralSetting/EmailTemplateMaster',
        element: EmailTemplateMaster
    },
    {
        path: '/Dealer/DealerMaster',
        element: DealerMaster
    },
    {
        path: '/Master/ManufactureMaster',
        element: ManufactureMaster
    },
    {
        path: '/SaleEntry/*',
        element: SaleEntry
    },
    {
        path: '/Dealer/DealerProfile',
        element: DealerProfile
    },
    {
        path: '/User/UserProfile',
        element: UserProfile
    },
    {
        path: '/Master/ModelMaster',
        element: ModalMaster
    },
    {
        path: '/Dashboard/DealerDashboard',
        element: DealerDashboard
    },
    {
        path: '/Dashboard/Dashboard',
        element: Dashboard
    },
    {
        path: '/Report/DealerReport',
        element: DealerReport
    },
    {
        path: '/Report/MISReport',
        element: MISReport
    },
    {
        path: '/Master/DealerTypeMaster',
        element: DealerTypeMaster
    },
    {
        path: '/CheckoutComponent',
        element: CheckoutComponent
    },
    {
        path: '/Report/PaymentReport',
        element: PaymentReport
    },
    {
        path: '/Master/PincodeMaster',
        element: PinCodeMaster
    },{
        path: '/Report/CancellationRequest',
        element: CancellationRequest
    },{
        path: '/Report/CancellationRequestReport',
        element: CancellationRequestReport
    },{
        path: '/Report/SaleCancellationRequest',
        element: SaleCancellationRequest
    }, {
        path: '/Report/CancelAndInitiatRefund',
        element: CancelAndInitiatRefund
    },{
        path: '/Report/SuccessPaymentReport',
        element: SuccessPaymentReport
    }, {
        path: '/Report/SaleReport',
        element: SaleReport
    },
    {
        path: '/Report/SMSReport',
        element: SMSReport
    }
];

export default AppRoutes;